<template>
  <div class="container">
    <div class="basic">
      <el-avatar shape="square" style="width: 80px;height: 80px;" :src="formData.resume_logo"></el-avatar>

      <div class="basic-right">
          <div class="col">
              <span style="color:#4c71db">{{ formData.resume_name }}</span>
              <span>
                  <label>性别：</label>
                  <a>{{ formData.resume_sex==1?"男": formData.resume_sex==2?"女":"保密"}}</a> 
                </span>
              <span>
                <label>年龄：</label>
                  <a>{{ formData.resume_age}}</a> 
              </span>
              <span>
                <label>毕业院校：</label>
                  <a>{{ formData.school }}</a> 
              </span>
              <span>
                <label>工作状态：</label>
                  <a>{{ formData.job_state|jobStateFilter }}</a> <!--工作状态 1在职 2考虑 3 离职-->
              </span>
              <span>
                <label>实践经验：</label>
                  <a>{{ formData.is_experience==1?"有":"无" }}</a> 
              </span><!--实践经验 1 有 2 无-->
          </div>

          <div class="col">
            <span>
              <label>期待职位：</label>
               <a>{{expect_job_str }}</a> 
            </span>

            <span>
              <label>期望薪资：</label>
               <a>{{ formData.expect_salary }}</a> 
            </span>

          </div>

      </div>
    </div>

    <div class="info">
      <p class="title">专业技能</p>
      <p class="desc">{{ formData.skill }}</p>
    </div>



    <div class="info">
      <p class="title">工作经历</p>
      <div class="desc">
        <p v-for="(item,index ) in formData.job_log" :key="index" style="display: flex;justify-content: space-around;">
            <span> {{item.start_date }}- {{item.end_date }}</span>
            <span>就职于：{{item.company }}</span>
        </p>
      </div>
    </div>


    <div class="info">
      <p class="title">个人介绍</p>
      <p class="desc">{{ formData.introduce }}</p>
    </div>
    
    

      
  </div>
</template>

<script>
import { userResumeInfo,userResumeUpdate,userResumeAdd } from "@/api/user/index";



export default {

  data () {
    return {
      resume_id:"",
      expect_job_str:"",

      formData:  {
        name:'',//
        resume_id:"",
        resume_imgs:'',//
        resume_name:'',//
        resume_sex:'',//
        resume_age:'',//
        resume_imgs	:[],
        resume_logo:'',//
        resume_mobile:'',//
        resume_email:'',//
        school: '',
        native_place: '',
        skill:'',//
        introduce:'',//
        photoFiles:[],//
        resume_identity:'',//
        job_state:'',//
        is_experience:null,//
        expect_job:[],//
        expect_salary:'',
        expect_salary_day:'',
        expect_salary_week:'',
        expect_salary_month:'',
        job_log:[],//地址信息
     
        expect_address:'',
        salary_type:'',//
        status:2,//
       

      }
    };
  },
 //工作状态 1 在职 2 考虑 3 离职 -->
  filters: {
    
    jobStateFilter(status) {
      const statusMap = {
        1: '在职',
        2: '考虑',
        3: '离职',
      }
      return statusMap[status]
    },
   
  },

  created(){
    if(this.$route.query&&this.$route.query.resume_id){
      this.resume_id=this.$route.query.resume_id;
      this.initInfo();

    }
  },
  methods: {
    initInfo(){
      var that=this;
      userResumeInfo({resume_id:this.resume_id}).then((response) => {
        if(response.code==200){
          that.formData=response.data;

        
          var selectStrs=[];
          for (let item of this.formData.expect_job ) {
            selectStrs.push(item.label)
          }
          this.expect_job_str=selectStrs.join(",");
          

        }else{
          that.$message.error("获取信息失败");
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>

  .basic{
    display: flex;
    justify-content: flex-start;

    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
    padding: 20px;
    margin-bottom: 40px;

    .basic-right{
      margin-left: 40px;
      display: flex;
      flex-direction: column;
      justify-content:space-around;
      flex: 1;

      .col{
        display: flex;
        justify-content: space-around;

        label{
          color: #a19797;
        }

        text{
          color: #565353;
        }
      }


    }

  }

  .info{
    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
    padding: 20px;
    margin-bottom: 40px;

    .title{
      padding: 10px 10px 10px 30px;
      border-bottom: 1px solid #dee1e1;
      position: relative;
    }

    .title:after {
      position: absolute; /*绝对定位*/
      top: 50%; /*Y轴方向偏移自身高度的50%*/
      transform: translatey(-50%); /*Y轴方向偏移微调*/
      left: 0; /*紧靠容器左边缘*/
      content:"";  /* 在标题前面插入文字 并设置样式 */ 
      font-size: 20px;
      width: 10px;
      height: 30px;  
      background-color: #4c71db; /*伪元素颜色*/
     }


    .desc{
      padding: 10px;

    }
  }
</style>
